import styles from "./layout.module.css";
import Logo from "../assets/logo.png";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";
import { useContext } from "react";

const MENU = [
    {
        grupo: "Geral",
        itens: [
            
        ],
    },
    {
        grupo: "Comunicação",
        itens: [
            { to: "/home", icone: "⊞", label: "Dashboard" },
            { to: "/comunicados", icone: "📢", label: "Comunicados" },
            { to: "/grupos",      icone: "👥", label: "Grupos" },
        ],
    },
    {
        grupo: "Configuração",
        itens: [
            { to: "/menu-config", icone: "📱", label: "Menu do App" },
        ],
    },
];

function iniciais(nome = "") {
    return nome.split(" ").slice(0, 2).map(p => p[0]).join("").toUpperCase();
}

export default function Sidebar() {
    const { logout, user } = useContext(AuthContext);

    return (
        <div className={styles.sidebar}>

            {/* LOGO */}
            <div className={styles.logo}>
                <img src={Logo} alt="logo" />
            </div>

            {/* USUÁRIO */}
            {user && (
                <div className={styles.sidebarUser}>
                    <div className={styles.sidebarAvatar}>
                        {iniciais(user.nomope ?? "U")}
                    </div>
                    <div className={styles.sidebarUserInfo}>
                        <span className={styles.sidebarUserNome}>{user.nomope}</span>
                    </div>
                </div>
            )}

            <div className={styles.sidebarDivider} />

            {/* NAVEGAÇÃO POR GRUPOS */}
            <nav className={styles.sidebarNav}>
                {MENU.map(({ grupo, itens }) => (
                    <div key={grupo} className={styles.navGrupo}>
                        <span className={styles.navGrupoLabel}>{grupo}</span>
                        {itens.map(({ to, icone, label }) => (
                            <NavLink
                                key={to}
                                to={to}
                                className={({ isActive }) =>
                                    `${styles.menuItem} ${isActive ? styles.active : ""}`
                                }
                            >
                                <span className={styles.menuIcone}>{icone}</span>
                                <span>{label}</span>
                            </NavLink>
                        ))}
                    </div>
                ))}
            </nav>

            {/* RODAPÉ — SAIR */}
            <div className={styles.sidebarFooter}>
                <div className={styles.sidebarDivider} />
                <button className={styles.btnSair} onClick={logout}>
                    <span className={styles.menuIcone}>→</span>
                    <span>Sair</span>
                </button>
            </div>

        </div>
    );
}
